import { createActions, handleActions, combineActions } from "redux-actions";

const defaultState = {
  activeStep: "",
  stepError: {},
  user: {},
  loading: false,
  otp: '',
};

export const {
  stepBegin,
  activeStep,
  stepError,
  setThumbnails,
  setStepStatus,
  setOtpStatus,
} = createActions(
  "ACTIVE_STEP",
  "STEP_ERROR",
  "STEP_BEGIN",
  "SET_THUMBNAILS",
  "SET_STEP_STATUS",
  "SET_OTP_STATUS"
);

export default handleActions(
  {
    [stepBegin]: (state, { data = {} }) => {
      return { ...defaultState, loading: true };
    },
    [activeStep]: (state, { payload = {} }) => {
      // console.log(payload);
      return { ...state, ...payload, loading: false };
    },
    [stepError]: (state, { payload = {} }) => {
      // console.log(payload);
      return { ...state, authError: payload };
    },
    [setThumbnails]: (state, { payload = {} }) => {
      // console.log(payload);
      return {
        ...state,
        thumbnails: payload,
      };
    },
    [setStepStatus]: (state, { payload = {} }) => {
      console.log(state);
      return {
        ...state,
        status: {
          ...state.status,
          ...payload,
        },
      };
    },
    [setOtpStatus]: (state, { payload = {} }) => {
      // console.log(payload);
      return { ...state, otp: payload, loading: false };
    },
  },
  defaultState
);
